export default {
  primary: '#e68738',
  secondary: '#364968',
  accent: '#82B1FF',
  error: '#FF3739',
  info: '#00D0BD',
  success: '#00D014',
  warning: '#FFB70F'
}
